export const DEFAULT_TOAST_DURATION = 2500; // ms = 2.5s
export class Toast {
    constructor(opts = null) {
        this.opts = {
            position: 'bottom-right',
            duration: DEFAULT_TOAST_DURATION
        };
        if (opts) {
            this.opts = opts;
        }
        this.elementRef = this.getElementRef();
    }
    show(message, opts = null) {
        this.present(message, opts, 'default');
    }
    info(message, opts = null) {
        this.present(message, opts, 'info');
    }
    success(message, opts = null) {
        this.present(message, opts, 'success');
    }
    error(message, opts = null) {
        this.present(message, opts, 'error');
    }
    dismiss() {
        this.elementRef.classList.remove('toast-show');
    }
    present(txt, opts = null, type) {
        const options = opts ? opts : this.opts;
        const position = options.position ? options.position : 'bottom-right';
        const duration = options.duration ? options.duration : (this.opts && this.opts.duration ? this.opts.duration : 2000);
        this.removeAllToastSubclasses();
        switch (type) {
            case 'success':
                this.elementRef.classList.add('toast-success');
                break;
            case 'info':
                this.elementRef.classList.add('toast-info');
                break;
            case 'error':
                this.elementRef.classList.add('toast-error');
                break;
        }
        this.elementRef.classList.add(`toast-${position}`);
        this.elementRef.textContent = txt;
        this.elementRef.classList.add('toast-show');
        this.timeout = setTimeout((that) => {
            that.elementRef.classList.remove(`toast-show`);
        }, (duration + 300), this); // +0.3s to duration for intro animation to finish playing
    }
    getElementRef() {
        let ref = document.querySelector('.toast');
        if (!ref) {
            ref = document.createElement('DIV');
            ref.classList.add('toast');
            document.body.appendChild(ref);
        }
        return ref;
    }
    removeAllToastSubclasses() {
        if (this.elementRef) {
            this.elementRef.classList.remove('toast-default', 'toast-info', 'toast-succes', 'toast-error');
        }
    }
}
